/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForUpdateUnitRate extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForUpdateUnitRate");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForUpdateUnitRate.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForUpdateUnitRate>): BackgroundJobPayloadForUpdateUnitRate {
        let obj = Object.assign(new BackgroundJobPayloadForUpdateUnitRate(), model);
        BackgroundJobPayloadForUpdateUnitRate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForUpdateUnitRate>): BackgroundJobPayloadForUpdateUnitRate {
        if (!model) return null;
        return BackgroundJobPayloadForUpdateUnitRate.newInstance(<BackgroundJobPayloadForUpdateUnitRate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForUpdateUnitRate) {
        if (!obj) return;

        models.BackgroundJobPayloadForUpdateUnitRate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForUpdateUnitRate): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForUpdateUnitRate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Target Cloud Account
     */
    service_account_id: string;

}
